import { useState, useEffect } from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { DateTime } from "luxon";
import { t } from "i18next";

// COMPONENTS
import { TableListBonosSP } from "@/shared/components/organisms/TableListBonosSP";
import { ListHistorial } from "@/shared/components/organisms/ListHistorial";
import { CalendarUser } from "@/shared/components/organisms/CalendarUser";
import { ButtonSoft } from "@/shared/components/atoms/ButtonSoft";
import { TabsUser } from "@/shared/components/organisms/TabsUser";

// APIS
import { useBondsQuery, useAssignedBondsQuery } from "@/app/bonds/bonds.api";
import { useAssistedsUserQuery } from "@/app/assisteds/assisteds.api";

// UTILS
import { formatDateTime } from "@/shared/utils/formatedDate";
import { selectUser } from "@/app/auth/auth.slice";

type AssistedsAssignmentProps = {
  handleOpenDialogAsingAssisteds: (event: any) => void,
  handleOpenDialogAssingBond: () => void,
  OptionsBrandedActiveSP: any,
  userSelected: any,
  branch_id: number,
};

export const AssistedsAssignment: React.FC<AssistedsAssignmentProps> = ({
  handleOpenDialogAsingAssisteds,
  handleOpenDialogAssingBond,
  OptionsBrandedActiveSP,
  userSelected,
  branch_id,
}: any) => {
  const { id } = useParams();
  const user = useSelector(selectUser);
  const [idBranch, setIdBranch] = useState(0);
  const [activityBonds, setActivityBonds] = useState([]);
  const [month, setMonth] = useState(DateTime.now().toFormat("yyyy-MM"));

  useEffect(() => {
    if (branch_id) {
      setIdBranch(branch_id);
    }
  }, [branch_id]);

  useEffect(() => {
    if (userSelected) {
      setIdBranch(userSelected.branch.id);

      setActivityBonds(
        userSelected.bondHistory.map((bond) => ({
          name: bond.bond ? bond.bond.name : "",
          description: t(bond.description),
          date: formatDateTime(bond.createdAt),
        }))
      );
    }
  }, [userSelected]);

  // TABS SP
  const [selectedTabSP, setSelectedTabSP] = useState(1);
  const tabsSP = [
    { id: 1, name: t("assisted.views.calendar") },
    { id: 2, name: t("bond.views.bonds") },
    { id: 3, name: t("user.views.history") },
  ];
  const handleTabChangeSP = (tabId: any) => {
    setSelectedTabSP(tabId);
  };

  const assistedsQuery = useAssistedsUserQuery(
    idBranch > 0 ? { branchId: idBranch, userId: id, month: month } : skipToken
  );

  const assignedBondsQuery = useAssignedBondsQuery(
    idBranch > 0 ? { branchId: idBranch, userId: id } : skipToken
  );

  const bondsQuery = useBondsQuery(
    idBranch > 0 ? { branchId: idBranch } : skipToken
  );

  return (
    <>
      <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 pb-3 mt-10  mb-5 md:mb-3">
        {t("assisted.views.title")}
      </h1>
      <TabsUser
        tabs={tabsSP}
        selectedTab={selectedTabSP}
        handleTabChange={handleTabChangeSP}
        button={
          <ButtonSoft
            text={t("user.views.manage_assisteds")}
            size="large"
          />
        }
      />
      {selectedTabSP === 1 ? (
        <div className="w-full">
          <CalendarUser
            initialDateTime={DateTime.now()}
            events={assistedsQuery.data ?? []}
            loading={assistedsQuery.isLoading}
            functionOpenModalActividades={() => {}}
            onEventClick={(lesson) => {
              handleOpenDialogAsingAssisteds(lesson);
            }}
            onMonthChange={(date) => {
              setMonth(date.toFormat("yyyy-MM"));
              assistedsQuery.refetch();
            }}
          />
        </div>
      ) : (
        <>
          {selectedTabSP === 2 ? (
            <>
              <TableListBonosSP
                user={userSelected ?? {}}
                loggedUser={user}
                assignedBonds={assignedBondsQuery.data ?? []}
                bonos={bondsQuery.data ?? []}
                titleBranded={t("bond.views.assign")}
                titleBrandedActiveFee={t("user.views.actions")}
                OptionsBrandedActiveFee={OptionsBrandedActiveSP}
                OnAssingBond={handleOpenDialogAssingBond}
                updateBondUserButton={() => {
                  console.log("Console")
                }}
              />
            </>
          ) : (
            <>
              {selectedTabSP === 3 ? (
                <>
                  <ListHistorial history={activityBonds} />
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}
